import {EducationService} from '@/services/education';
import Routes from "@/router/routes";
import ToastMixin from '@/mixins/toast-mixin';

export default {
  name: 'preview-educ-file-mixin',
  mixins: [ToastMixin],
  data() {
    return {
      educAttachedFiles: null,
    }
  },
  methods: {
    async getEducAttachedFiles(files, msgid, token) {
      try {
        const requestFileAttachments = files.map(({key}) => {
          return EducationService.getAttachedFile(msgid, key, token);
        });
        const response = await Promise.all(requestFileAttachments);

        const isFilesAvailable = response.every(({data}) => data.result === 1);

        if (isFilesAvailable) {
          this.educAttachedFiles = response.map(({data}) => data.url);
          this.viewFiles();
        } else {
          throw Error();
        }

      } catch (error) {
        console.error(error);
        this.showToast({
          text: 'Failed to view file. Please try again later.',
          theme: 'danger',
        });
      }
    },
    getFilesAttached(files, msgid, token) {
      if (!this.educAttachedFiles) {
        this.getEducAttachedFiles(files, msgid, token);
      } else {
        this.viewFiles();
      }
    },
    viewFiles() {
      this.$router.push({
        name: Routes.PREVIEW_FILE,
        params: {
          file: this.educAttachedFiles,
          filesView: true,
          showHeaderRightActions: false,
        },
      })
    },
  },
}
